//# sourceMappingURL=/s/files/1/0256/7979/0179/t/21/assets/custom.js.map?v=1653274686
document.addEventListener("DOMContentLoaded", function () {

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  /* ------------------------------------
     1️⃣ VARIANT → THUMBNAIL SYNC
  ------------------------------------ */

  document.addEventListener('variant:change', function (event) {

    const variant = event.detail.variant;
    if (!variant || !variant.featured_media) return;

    const mediaId = variant.featured_media.id;

    const thumbnailBtn = document.querySelector(
      `.product__thumbnail-item[data-media-id="${mediaId}"]`
    );

    if (thumbnailBtn) {
      thumbnailBtn.click();
    }

  });


  /* ------------------------------------
     2️⃣ THUMBNAIL → VARIANT SYNC
  ------------------------------------ */

  const thumbnails = document.querySelectorAll('.product__thumbnail-item');

  thumbnails.forEach(thumbnail => {

    thumbnail.addEventListener('click', function () {

      const mediaId = this.getAttribute('data-media-id');
      if (!mediaId) return;

      fetch(window.location.pathname + ".js")
        .then(res => res.json())
        .then(product => {

          const matchedVariant = product.variants.find(v =>
            v.featured_media && v.featured_media.id == mediaId
          );

          if (!matchedVariant) return;

          const variantInput = productForm.querySelector(
            `input[value="${matchedVariant.id}"]`
          );

          if (variantInput) {
            variantInput.checked = true;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

        });

    });

  });

});